import React from 'react';
import { Box, Typography, Button, Card, CardContent, useMediaQuery, useTheme } from '@mui/material';
import { COLOR_PRIMARY_2, COLOR_TEXT_1 } from 'src/colors';
import SubmarketsDataGrid from '../HOC/SubMarketsTab/SubmarketsDataGrid';
import TooltipNew from 'src/App/HOC/Tooltips/TooltipNew';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

interface TopSubmarketsProps {
  submarkets: any[];
  currency: string;
  subscriptionPlan: string;
  handleOnSampleClick: (plan?: string) => void;
  hoveredSubmarketId: string | null;
  setHoveredSubmarketId: (id: string | null) => void;
  setDashboardLayoutView: (
    view: 'submarkets' | 'dashboard' | 'map' | 'discovery' | 'compare'
  ) => void;
  isLoading?: boolean;
}

const TopSubmarkets: React.FC<TopSubmarketsProps> = ({
  submarkets,
  currency,
  subscriptionPlan,
  handleOnSampleClick,
  hoveredSubmarketId,
  setHoveredSubmarketId,
  setDashboardLayoutView,
  isLoading = false,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  if (isLoading || !submarkets || submarkets.length === 0) {
    return null;
  }

  // Sort submarkets by revenue potential (descending) and take top 5
  const topSubmarkets = [...submarkets]
    .sort((a, b) => (b.revenue || 0) - (a.revenue || 0))
    .slice(0, 5);

  return (
    <Card
      sx={{
        background: '#fff',
        borderRadius: 3,
        boxShadow: '0 2px 12px 0 rgba(16,30,54,.06)',
        border: '1px solid #E0E0E0',
        overflow: 'visible',
        position: 'relative',
        p: 0,
        m: 0,
        width: '100%',
        maxWidth: '100vw',
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 700,
              color: COLOR_TEXT_1,
              fontSize: matches ? '16px' : '18px',
              lineHeight: 1.2,
            }}
          >
            Top Submarkets by Revenue 
          </Typography>
          <Button
            variant="outlined"
            onClick={() => setDashboardLayoutView('submarkets')}
            sx={{ color: COLOR_PRIMARY_2, borderColor: COLOR_PRIMARY_2 }}
          >
            View All Submarkets
          </Button>
        </Box>

        <SubmarketsDataGrid
          submarkets={topSubmarkets}
          currency={currency}
          subscriptionPlan={subscriptionPlan}
          handleOnSampleClick={handleOnSampleClick}
          hoveredSubmarketId={hoveredSubmarketId}
          setHoveredSubmarketId={setHoveredSubmarketId}
          showActions={false}
          maxRows={5}
          height="400px"
        />
      </CardContent>
    </Card>
  );
};

export default TopSubmarkets;
